<template>
<div class="row">
  <div class="col">
    <h5 class="page-title mb-4">
      <span class="font-weight-normal">{{ 'JOB' | translate }}:</span> {{ jobName }}
      <span v-if='pauseInProgress' class="badge text-uppercase ml-4 badge-primary">
        <i class="fa mr-1 fa-refresh fa-spin"></i>
        {{ 'PAUSE_IN_PROGRESS' | translate('job') }}
      </span>
      <span v-else class="badge text-uppercase ml-4" :class="statusBadgeClass.badge">
        <i class="fa mr-1" :class="statusBadgeClass.icon" v-if="statusBadgeClass.icon"></i>
        {{ jobStatus | translate('job') }}
      </span>
    </h5>
  </div>
  <div class="col-auto text-right font-weight-semibold">
    {{ 'CREATION_DATE' | translate }}: <em>{{ creationDate }}</em>
  </div>
</div>
</template>

<script>
export default {
  props: ['jobName', 'jobStatus', 'creationDate', 'pauseInProgress'],
  computed: {
    statusBadgeClass: function() {
      switch (this.jobStatus) {
        case 'COMPLETE':
          return { badge: 'badge-success', icon: 'fa-check' };
        case 'RUNNING':
          return { badge: 'badge-info', icon: 'fa-refresh fa-spin' };
        case 'PAUSED':
          return { badge: 'badge-primary', icon: 'fa-pause' };
        case 'PENDING':
          return { badge: 'badge-primary', icon: 'fa-clock-o' };
        case 'CANCELED':
          return { badge: 'badge-warning', icon: 'fa-user-times' };
        case 'EXPIRED':
          return { badge: 'badge-warning', icon: 'fa-clock-o' };
        case 'FAILED':
        case 'VALIDATION_FAILED':
          return { badge: 'badge-danger', icon: 'fa-times' };
        default:
          return { badge: 'badge-secondary', icon: null };
      }
    }
  }
}
</script>

<style scoped>
  .page-title .badge {
    font-size: 65%;
  }
</style>



// WEBPACK FOOTER //
// src/components/job/JobDetailsHeader.vue